import { VehicleService } from '@/api-proxy/serviceAvailability'
import { Alert, Button, Group, Stack, Text } from '@mantine/core'
import { isEmpty } from 'lodash-es'
import { useTranslation } from 'react-i18next'

const serviceMessage = {
  focus: 'focusServiceUnreachable',
  navigation: 'navigationServiceUnreachable',
} as const

export const ServiceUnreachableBanner = ({
  services,
  onRetry,
}: {
  services: VehicleService[]
  onRetry: () => void
}) => {
  const { t } = useTranslation(['hardware', 'common'])

  if (isEmpty(services)) return null

  return (
    <Stack gap="xs">
      {services.map(service => (
        <Alert key={service} color="red" variant="filled" role="status">
          <Group justify="space-between" align="center" wrap="nowrap">
            <Text size="sm">{t(serviceMessage[service])}</Text>
            <Button size="xs" variant="white" color="red" onClick={onRetry}>
              {t('retry', { ns: 'common' })}
            </Button>
          </Group>
        </Alert>
      ))}
    </Stack>
  )
}

const VehicleServiceNotice = ({
  services,
  cameraStatusError,
  onRetry,
}: {
  services: VehicleService[]
  cameraStatusError: boolean
  onRetry: () => void
}) => {
  const { t } = useTranslation(['hardware', 'common'])

  if (isEmpty(services) && !cameraStatusError) return null

  if (!isEmpty(services)) {
    return (
      <Stack mb="md" gap="xs">
        {services.map(service => (
          <Alert key={service} color="red" variant="light" title={t(serviceMessage[service])}>
            <Group justify="flex-end">
              <Button size="xs" variant="light" color="red" onClick={onRetry}>
                {t('retry', { ns: 'common' })}
              </Button>
            </Group>
          </Alert>
        ))}
      </Stack>
    )
  }

  return (
    <Alert color="red" variant="light" mb="md" title={t('cameraStatusFailed')}>
      <Group justify="space-between" align="center">
        <Text size="sm">{t('cameraStatusFailedMessage')}</Text>
        <Button size="xs" variant="light" color="red" onClick={onRetry}>
          {t('retry', { ns: 'common' })}
        </Button>
      </Group>
    </Alert>
  )
}

export default VehicleServiceNotice
